import styles from './index.module.scss';
import { utility } from '@phi/components';
import { PropType, defineComponent, h } from 'vue';

type Align =
    'center'
    | 'flex-start';

type Space =
    'start'
    | 'between';

export const Label = defineComponent({
    props: {
        align: {
            required: false,
            type: String as PropType<Align>,
            default: 'center',
        },

        space: {
            required: false,
            type: String as PropType<Space>,
            default: 'start',
        },
    },

    render() {
        return h('label', {
            class: {
                'label': true,
                [utility.flex]: true,
                [utility.align_center]: this.align === 'center',
                [utility.align_flex_start]: this.align === 'flex-start',
                [utility.gap_3]: true,
                [styles.label]: true,
                [utility.space_between]: this.space === 'between',
                [utility.cursor_auto]: true,
            },
        }, [
            this.$slots.label ? this.$slots.label() : '',
            this.$slots.input ? this.$slots.input() : '',
        ]);
    },
});
